import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components/core/Typography';

import { SearchBox } from 'components/search/SearchBox';
import { MarketingFooter } from 'components/landing/MarketingFooter';


import './PLPFooterSection.scss';

export function PLPFooterSection({ pageType, location, handleSearch }) {
    const pageTypeFormat = pageType === 'Self-Storage' ? ' Storage' : `${pageType} Storage Spaces`; // google keyword
    const title = `Find and Reserve ${location ?? ''} ${pageTypeFormat} in Minutes`;
    return (
		<>
			<div className="search-box-footer">
				<div className="section-content">
					<div className="box-container">
						<Paragraph className="search-box-title">
							{title}
						</Paragraph>
						<Paragraph
							className="search-box-description"
							last
						>
							Make a free reservation, no credit-card required
						</Paragraph>
						<SearchBox
							handleSearch={handleSearch}
							inputLabel="Enter address, city, or zip"
							hideOnScroll
							buttonText="Find Storage"
						/>
					</div>
				</div>
			</div>
			<MarketingFooter />
		</>
	);
}

PLPFooterSection.propTypes = {
    pageType: PropTypes.string,
    location: PropTypes.string,
    handleSearch: PropTypes.func
};

export default PLPFooterSection;